<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M10.7713 16.4998C10.0537 16.4379 9.32741 16.4062 8.59375 16.4062H7.8125C5.22367 16.4062 3.125 14.3076 3.125 11.7187C3.125 9.12991 5.22367 7.03125 7.8125 7.03125H8.59375C9.32741 7.03125 10.0537 6.99965 10.7713 6.93773M10.7713 16.4998C11.0347 17.5015 11.3789 18.4705 11.7965 19.3994C12.0543 19.9727 11.8586 20.6591 11.3142 20.9734L10.6305 21.3681C10.0561 21.6997 9.31833 21.4902 9.04001 20.8882C8.38729 19.4764 7.88063 17.9832 7.53943 16.4281M10.7713 16.4998C10.37 14.9734 10.1562 13.3711 10.1562 11.7187C10.1562 10.0664 10.37 8.46406 10.7713 6.93773M10.7713 16.4998C14.0625 16.7837 17.1713 17.7054 19.9737 19.1405M10.7713 6.93773C14.0625 6.65375 17.1713 5.73211 19.9737 4.29697M19.9737 4.29697C19.8511 3.90203 19.7189 3.51128 19.5775 3.125M19.9737 4.29697C20.5309 6.09195 20.8914 7.97357 21.0298 9.91658M19.9737 19.1405C19.8511 19.5355 19.7189 19.9262 19.5775 20.3125M19.9737 19.1405C20.5309 17.3455 20.8914 15.4639 21.0298 13.5209M21.0298 9.91658C21.5463 10.3465 21.875 10.9942 21.875 11.7187C21.875 12.4433 21.5463 13.091 21.0298 13.5209M21.0298 9.91658C21.0722 10.5118 21.0938 11.1127 21.0938 11.7187C21.0938 12.3248 21.0722 12.9257 21.0298 13.5209"
				:stroke="color"
				stroke-width="1.5625"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgMegaphone',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
